import * as React from 'react';
import { useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import CloseIcon from "@mui/icons-material/Close";

const drawerWidth = 420;

function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 2,
  });
}

function DrawerAppBar(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const currLoc = window?.location?.pathname
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        flexGrow: 1,
        columnGap: ".5rem",
        padding: ".75rem"
      }}>
        <Box
          onClick={() => { goToPage("home"); }}
          sx={{
            display: 'flex',
            flexDirection: "column",
            cursor: 'pointer'
          }}>
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: 'column',
          }}>
            <Typography
              variant="h6"
              component="div"
            >
              <img
                src={"/logo.webp"}
                alt="Logo"
                height={30}
                width={'auto'}
              />
            </Typography>
            <Typography
              variant="span"
              component="span"
              sx={{
                marginTop: '0.25rem',
                color: '#6d4cb1',
                fontSize: '0.75rem',
                lineHeight: '0.75rem',
                textAlign: 'center'
              }}
            >
              Pioneering Solution
            </Typography>
          </Box>
        </Box>
        <CloseIcon sx={{ color: '#6d4cb1', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleDrawerToggle() }} />
      </Box>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton sx={{ textAlign: 'start', fontWeight: '600', backgroundColor: currLoc === '/' ? '#F4F6F8' : '' }}
            onClick={() => { goToPage("home"); }}>
            <ListItemText primary={"Home"} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={{ textAlign: 'start', fontWeight: '600', backgroundColor: currLoc === '/blogs' ? '#F4F6F8' : '' }}
            onClick={() => { goToPage("blogs"); }}>
            <ListItemText primary={"Blogs"} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={{ textAlign: 'start', fontWeight: '600', backgroundColor: currLoc === '/find-an-expert' ? '#F4F6F8' : '' }}
            onClick={() => { goToPage("expert"); }}>
            <ListItemText primary={"Find an Expert"} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={{ textAlign: 'start', fontWeight: '600', backgroundColor: currLoc === '/find-a-task' ? '#F4F6F8' : '' }}
            onClick={() => { goToPage("task"); }}>
            <ListItemText primary={"Find a Task"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const goToPage = (page) => {

    switch (page) {
      case "home":
        navigate("/");
        break;

      case "blogs":
        navigate("/blogs");
        break;

      case "expert":
        navigate("/find-an-expert");
        break;

      case "task":
        navigate("/find-a-task");
        break;

      case "login":
        navigate("/login");
        break;

      case "register":
        navigate("/signup");
        break;

      default:
        break;
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', px: "1rem !important" }}>
        <CssBaseline />
        <ElevationScroll {...props}>
          <AppBar component="nav" id="hgjg" sx={{ backgroundColor: "#fff", elevation: 4, borderBottom: "1px solid #6d4cb1" }}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { md: 'none' }, color: "#000" }}
              >
                <MenuIcon />
              </IconButton>
              <Box
                onClick={() => { goToPage("home"); }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: 'column',
                  alignItems: "flex-start",
                  flexGrow: 1,
                  columnGap: ".5rem",
                  cursor: 'pointer'
                }}>
                <Box sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: 'column',
                }}
                onClick={() => { goToPage("home"); }}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, minWidth: "max-content", cursor: 'pointer' }}
                  >
                      <img
                        src={"/logo.webp"}
                        alt="Logo"
                        height={30}
                        width={'auto'}
                      />
                  </Typography>
                  <Typography
                    variant="span"
                    component="span"
                    sx={{
                      display: { xs: 'none', sm: 'none', md: 'block' },
                      marginTop: '0.25rem',
                      color: '#6d4cb1',
                      fontSize: '0.75rem',
                      lineHeight: '0.75rem',
                      textAlign: 'center',
                    }}
                  >
                    Pioneering Solution
                  </Typography>
                </Box>
              </Box>

              <Box sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'flex'
                },
                columnGap: {
                  lg: ".25rem",
                  md: "0.75rem"
                },
                paddingRight: ".75rem"
              }}>

                <Button sx={{ color: '#000', fontWeight: '600', letterSpacing: '1px' }}
                  onClick={() => {
                    goToPage("home");
                  }}>
                  {'Home'}
                </Button>

                <Button sx={{ color: '#000', fontWeight: '600', letterSpacing: '1px' }}
                  onClick={() => {
                    goToPage("blogs");
                  }}>
                  {"Blogs"}
                </Button>

                <Button sx={{ color: '#000', fontWeight: '600', letterSpacing: '1px' }}
                  onClick={() => {
                    goToPage("expert");
                  }}>
                  {"Find an Expert"}
                </Button>

                <Button sx={{ color: '#000', fontWeight: '600', letterSpacing: '1px', }}
                  onClick={() => {
                    goToPage("task");
                  }}>
                  {"Find a Task"}
                </Button>

              </Box>

              <Box sx={{ display: { xs: 'flex', sm: 'flex' }, columnGap: ".75rem" }}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "#212b36",
                    "&:hover": {
                      backgroundColor: "#381b72",
                      color: "#fff",
                    },
                  }}
                  onClick={() => {
                    goToPage("login");
                  }}
                >
                  {"Sign In"}
                </Button>

                <Button
                  variant="contained"
                  sx={{ color: "#fff" }}
                  onClick={() => {
                    goToPage("register");
                  }}
                >
                  {"Sign Up"}
                </Button>
              </Box>

            </Toolbar>
          </AppBar>
        </ElevationScroll>
        <nav>
          <Drawer
            // container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'block', md: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', maxWidth: drawerWidth, width: '100vw', height: '100vh !important' },
            }}
            disableScrollLock={true}
          >
            {drawer}
          </Drawer>
        </nav>
      </Box>
      <Box sx={{ marginBottom: "3.5rem" }}></Box>
    </>
  );
}

export default DrawerAppBar;
